import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DropdownInputsSignalService {
  private reloadSubject$ = new Subject<string | number>();
  reload$ = this.reloadSubject$.asObservable();

  constructor() { }

  triggerReload(id: string | number): void {
    this.reloadSubject$.next(id);
  }
}
